import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { User } from '@app/models/user.model';
import { SetUserImage } from '@app/store/data/data.classes';
import { Store } from '@ngxs/store';
import { EMPTY, map, Observable, startWith, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-user-search',
  templateUrl: './user-search.component.html',
  styleUrls: ['./user-search.component.scss'],
})
export class UserSearchComponent implements OnChanges, OnDestroy {
  @Input() userList!: User[];
  @Output() userChange = new EventEmitter<User>();
  form: FormControl;
  filtered$: Observable<User[] | null>;
  private onDestory$: Subject<void>;
  private allowFetchPerSection: number = 5;
  constructor(public store: Store) {
    this.onDestory$ = new Subject();
    this.form = new FormControl('');
    this.filtered$ = this.form.valueChanges.pipe(
      startWith(''),
      map(
        (value) =>
          this.userList?.filter(
            ({ name, kana }) => name.includes(value) || kana?.includes(value)
          ) ?? null
      )
    );
  }
  ngOnDestroy(): void {
    // throw new Error('Method not implemented.');
    this.onDestory$.next();
    // this.store.dispatch(new RemoveUserImage());
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userList']) {
      new Array(this.allowFetchPerSection).fill(0).map((_, i) => this.avatarTrigger(i));
    }
  }

  avatarTrigger(i: number = 0) {
    if (i < 0 || i >= this.userList.length) return EMPTY;
    const { daicd } = this.userList[i];
    return this.store.dispatch(new SetUserImage(daicd)).pipe(takeUntil(this.onDestory$)).subscribe(() => {
      this.avatarTrigger(i + this.allowFetchPerSection);
    })
  }

  onChange(user: User): void {
    this.userChange.emit(user);
  }
}
